<template>
  <qc-container title="租赁合同编辑">
    <el-form class="mt20" ref="ruleForm" :model="addRow"  label-width="100px">
      <form-item-rule label="合同名称" prop="name">
        <el-input v-model="addRow.name"></el-input>
      </form-item-rule>
      <form-item-rule label="合同内容" prop="content">
        <ueditor ref="ue"></ueditor>
      </form-item-rule>
      <el-form-item label="替换规则">
        <div class="flex-cc">
          <div class="message">订单编号：${code}</div>
          <div class="message">商品名称：${name}</div>
          <div class="message">商品数量：${count}</div>
          <div class="message">收货地址：${address}</div>
          <div class="message">租赁开始时间：${startTime}</div>
          <div class="message">租赁结束时间：${endTime}</div>
          <div class="message">押金：${deposit}</div>
          <div class="message">每天租赁金额：${leaseMoney}</div>
          <div class="message">租金合计：${leaseSumMoney}</div>
          <div class="message">最小租赁天数：${minLeaseDay}</div>
        </div>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="addRow.remark" type="textarea" :rows="5"></el-input>
      </el-form-item>

      <el-form-item class="tc">
        <el-button @click="returnLast()">取消</el-button>
        <el-button type="primary" @click="doSave()">确定</el-button>
      </el-form-item>
    </el-form>
  </qc-container>
</template>

<script>
import FormItemRule from "/src/components/el/form-item-rule";


import SimpleDict from "/src/components/dict/SimpleDict";
import QcContainer from "@/components/el/layout/qc-container.vue";
import Ueditor from "@/components/base/ueditor.vue";
export default {
  name: "contract-add",
  components: {Ueditor, QcContainer, FormItemRule,SimpleDict},
  data() {
    return {
      visible: false,
      addRow: {name:"",content:"",remark:""}
    }
  },
  mixins: [tableBase],
  methods: {
    doSave(){
      this.addRow.content = this.$refs.ue.getContent();
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/business/contract/addOrUpdate", this.addRow, () => {
            this.returnLast();
          })
        }
      })
    }
  },
  mounted() {
    if(this.$route.query.id){
      this.simplePost("/api/mgr/business/contract/detail",{id:this.$route.query.id},(res)=>{
        this.addRow = res.data;
        this.$refs.ue.init(this.addRow.content);
      })
    }
  }
}
</script>

<style lang="less" scoped>
.message{
  color: #999999;
}
</style>
